import apiClient from '@/utils/apiClient';

const CALENDAR_ERROR_LOGS = '/api/calendars/cal-com/errors';

export interface TCalendarErrorLog {
	id: string;
	eventTypeId: string;
	timestamp: number;
	request: {
		url: string;
		method: string;
		headers: {
			[key: string]: string;
		};
		data: any;
	};
	response: {
		message: string;
		[key: string]: any;
	};
	context: {
		stack?: string;
		[key: string]: any;
	};
}

export const getCalendarErrorLogs = async (eventTypeId: string): Promise<TCalendarErrorLog[]> => {
	const response = await apiClient.request({
		method: 'GET',
		endPoint: `${CALENDAR_ERROR_LOGS}?eventTypeId=${eventTypeId}`,
	});
	return response.errors;
};
